import React, { useState, useEffect } from 'react';
import { Box, Typography, IconButton, Button, Fade } from '@mui/material';
import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material';

import img1 from '../../assets/img/header/about-img.png';
import img2 from '../../assets/img/header/blog-img.png';
import img3 from '../../assets/img/header/img-6.png';

const slides = [
  {
    id: 1,
    image: img1,
    title: 'Bienvenido a Nuestra Tienda',
    subtitle: 'Los mejores productos al mejor precio',
    button: 'Ver Productos',
  },
  {
    id: 2,
    image: img2,
    title: 'Ofertas Exclusivas',
    subtitle: 'Descuentos hasta 50% solo por hoy',
    button: 'Ver Ofertas',
  },
  {
    id: 3,
    image: img3,
    title: 'Nuevos Lanzamientos',
    subtitle: 'Descubrí las últimas novedades del mes',
    button: 'Explorar',
  },
];

const HeaderCarousel = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % slides.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);

  const handlePrev = () => {
    setActiveIndex((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setActiveIndex((prev) => (prev + 1) % slides.length);
  };

  return (
    <Box sx={{ position: 'relative', width: '100%',  overflow: 'hidden' }}>
      {/* Contenedor de diapositivas */}
      <Box sx={{ position: 'relative', height: { xs: 250, sm: 350, md: 500 } }}>
        {slides.map((slide, index) => (
          <Fade
            in={index === activeIndex}
            timeout={800}
            key={slide.id}
            unmountOnExit
          >
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundImage: `url(${slide.image})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#fff',
                textAlign: 'center',
              }}
            >
              {/* Capa oscura */}
              <Box
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  backgroundColor: 'rgba(0,0,0,0.4)',
                }}
              />

              {/* Texto 
              <Box sx={{ position: 'relative', zIndex: 1, px: 2 }}>
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 'bold',
                    mb: 1,
                    fontSize: { xs: '1.8rem', md: '3rem' },
                  }}
                >
                  {slide.title}
                </Typography>
                <Typography
                  variant="h6"
                  sx={{ mb: 3, fontSize: { xs: '1rem', md: '1.5rem' } }}
                >
                  {slide.subtitle}
                </Typography>
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: '#1976d2',
                    '&:hover': { backgroundColor: '#1259a2' },
                  }}
                >
                  {slide.button}
                </Button>
              </Box>
              */}
            </Box>
          </Fade>
        ))}

        {/* Botones de navegación centrados verticalmente */}
        <IconButton
          onClick={handlePrev}
          sx={{
            position: 'absolute',
            top: '50%',
            left: 15,
            transform: 'translateY(-50%)',
            color: '#fff',
            backgroundColor: 'rgba(0,0,0,0.3)',
            '&:hover': { backgroundColor: 'rgba(0,0,0,0.6)' },
          }}
        >
          <ArrowBackIos />
        </IconButton>

        <IconButton
          onClick={handleNext}
          sx={{
            position: 'absolute',
            top: '50%',
            right: 15,
            transform: 'translateY(-50%)',
            color: '#fff',
            backgroundColor: 'rgba(0,0,0,0.3)',
            '&:hover': { backgroundColor: 'rgba(0,0,0,0.6)' },
          }}
        >
          <ArrowForwardIos />
        </IconButton>
      </Box>
    </Box>
  );
};

export default HeaderCarousel;
